
import { PipesModule } from '@app/pipes/pipes.module';import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RoleFormPage } from './role-form.page';

const routes: Routes = [
  {
    path: '',
    component: RoleFormPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes),
    PipesModule],
  exports: [RouterModule],
})
export class RoleFormPageRoutingModule {}
